/* Reiterreihe (sections/mhsys-reiterreihe.liquid, Inhaber 24.10.2026): Reiter schalten zwischen Slidern um.
 * Muster „Tabs“ der WAI-ARIA Authoring Practices: ein Reiter im Tab-Lauf (tabindex), Pfeil links/rechts, Pos1, Ende wechseln und
 * zeigen sofort (automatische Aktivierung). Nach dem Umschalten ein resize-Ereignis, damit assets/mhsys-slider.js die Pfeile des
 * sichtbar gewordenen Sliders neu misst (verborgen hatte er keine Breite). Läuft nur, wo die Section steht.
 *
 * Budget-Reiter (Roadmap 1.113): ein Slider mit data-mhsys-rtr-nachladen hat in den ersten 50 Produkten der Kollektion
 * nicht genug im Preisbereich gefunden. Dann holt das Skript einmal die Kacheln über Shopifys Preisfilter (Adresse im
 * Attribut, Section mhsys-kategorien-inhalt) und hängt die fehlenden hinten an - bis data-mhsys-rtr-anzahl. Für den
 * sichtbaren Reiter, sobald die Reihe 600 px vor dem Bildschirm ist, für die anderen beim Überfahren, Antippen oder
 * Fokussieren ihres Reiters. Keine Treffer: ein Satz statt des leeren Platzhalters. Kein Dauer-Timer.
 */
(function () {
  'use strict';

  function produktPfad(kachel) {
    var a = kachel.querySelector('a[href*="/products/"]');
    return a ? a.pathname : '';
  }

  // Einmal je Slider: fehlende Kacheln über den Preisfilter holen und hinten anhängen
  function nachladen(slider) {
    if (!slider) return;
    var url = slider.getAttribute('data-mhsys-rtr-nachladen');
    if (!url) return;
    slider.removeAttribute('data-mhsys-rtr-nachladen');
    var ziel = parseInt(slider.getAttribute('data-mhsys-rtr-anzahl'), 10) || 10;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var da = {};
        Array.prototype.forEach.call(slider.children, function (k) { da[produktPfad(k)] = true; });
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inhalt = doc.querySelector('[data-mhsys-kateg-inhalt]');
        var neu = inhalt ? Array.prototype.slice.call(inhalt.children) : [];
        neu.forEach(function (k) {
          if (slider.children.length >= ziel) return;
          var pfad = produktPfad(k);
          if (!pfad || da[pfad]) return;
          da[pfad] = true;
          slider.appendChild(document.importNode(k, true));
        });
        if (!slider.children.length) {
          var leer = document.createElement('p');
          leer.className = 'mhsys-rtr__leer';
          leer.textContent = 'In dem Preisbereich is grad nix da – schau dir alle an.';
          slider.parentNode.insertBefore(leer, slider);
          slider.hidden = true;
        }
        window.dispatchEvent(new Event('resize'));
      })
      .catch(function () {});
  }

  function verbinden(wurzel) {
    if (wurzel.dataset.mhsysRtrBereit) return;
    wurzel.dataset.mhsysRtrBereit = '1';
    var tabs = Array.prototype.slice.call(wurzel.querySelectorAll('[role="tab"]'));

    function sliderVon(tab) {
      var tafel = document.getElementById(tab.getAttribute('aria-controls'));
      return tafel ? tafel.querySelector('[data-mhsys-rtr-nachladen]') : null;
    }

    // sichtbarer Reiter: sobald die Reihe in die Nähe kommt
    var erster = wurzel.querySelector('[role="tabpanel"]:not([hidden]) [data-mhsys-rtr-nachladen]');
    if (erster) {
      if ('IntersectionObserver' in window) {
        var beobachter = new IntersectionObserver(function (eintraege) {
          if (!eintraege.some(function (e) { return e.isIntersecting; })) return;
          beobachter.disconnect();
          nachladen(erster);
        }, { rootMargin: '600px 0px' });
        beobachter.observe(wurzel);
      } else {
        nachladen(erster);
      }
    }
    if (tabs.length < 2) return;

    function zeigen(nr, fokus) {
      tabs.forEach(function (tab, i) {
        var an = i === nr;
        tab.setAttribute('aria-selected', an ? 'true' : 'false');
        if (an) tab.removeAttribute('tabindex'); else tab.setAttribute('tabindex', '-1');
        var tafel = document.getElementById(tab.getAttribute('aria-controls'));
        if (tafel) tafel.hidden = !an;
      });
      nachladen(sliderVon(tabs[nr]));
      if (fokus) tabs[nr].focus();
      window.dispatchEvent(new Event('resize'));
    }

    tabs.forEach(function (tab, i) {
      // die Kacheln eines anderen Reiters schon holen, wenn er gleich gewählt wird
      ['pointerenter', 'focus', 'touchstart'].forEach(function (art) {
        tab.addEventListener(art, function () { nachladen(sliderVon(tab)); }, { once: true, passive: true });
      });
      tab.addEventListener('click', function () { zeigen(i, false); });
      tab.addEventListener('keydown', function (e) {
        var ziel = null;
        if (e.key === 'ArrowRight') ziel = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') ziel = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') ziel = 0;
        else if (e.key === 'End') ziel = tabs.length - 1;
        if (ziel === null) return;
        e.preventDefault();
        zeigen(ziel, true);
      });
    });
  }

  function starten() {
    document.querySelectorAll('[data-mhsys-rtr]').forEach(verbinden);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();
  document.addEventListener('shopify:section:load', starten);
})();
